<div class="confirmacion-page" [class.confirmacion-page--receipt]="!!codigoSeguimiento">
  <ng-container *ngIf="codigoSeguimiento; else consultaDirectaTpl">
    <section class="confirmacion-receipt">
      <div class="confirmacion-receipt__icon" aria-hidden="true">
        <i class="material-icons">check</i>
      </div>

      <header class="confirmacion-receipt__header">
        <h1>Denuncia recibida exitosamente</h1>
        <p>
          Su compromiso con la integridad fortalece nuestra organización.
          Su reporte ha sido procesado de forma segura y confidencial.
        </p>
      </header>

      <div class="error-mensaje" *ngIf="uploadWarning">{{ uploadWarning }}</div>

      <div class="confirmacion-receipt__grid">
        <article class="receipt-code-card">
          <span class="receipt-card__eyebrow">Código de seguimiento</span>
          <div class="receipt-code-card__value">{{ codigoSeguimiento }}</div>
          <button type="button" class="receipt-code-card__copy" (click)="copiarCodigo()">
            {{ copiado ? 'Copiado' : 'Copiar' }}
          </button>
        </article>

        <article class="receipt-info-card">
          <span class="receipt-info-card__icon" aria-hidden="true">i</span>
          <p>
            <strong>Importante:</strong> Guarde este código en un lugar seguro.
            Es el único medio para consultar su reporte.
          </p>
        </article>
      </div>

      <section class="quick-consulta">
        <span class="quick-consulta__label">Consulta rápida de estado</span>

        <div class="quick-consulta__row">
          <input
            id="codigoConsulta"
            aria-label="Ingrese otro código de seguimiento"
            type="text"
            [(ngModel)]="codigoConsulta"
            placeholder="Ingrese otro código de seguimiento..."
            (ngModelChange)="onCodigoConsultaChange()"
            (keyup.enter)="consultarEstado()">

          <button class="btn-primary btn-primary--quick" (click)="consultarEstado()" [disabled]="buscando">
            <span>{{ buscando ? 'Consultando...' : 'Consultar →' }}</span>
          </button>
        </div>

        <div class="error-mensaje" *ngIf="errorConsulta">{{ errorConsulta }}</div>
      </section>

      <!-- Resultado inline (receipt mode) -->
      <article class="resultado-card" *ngIf="denunciaConsultada">
        <div class="resultado-card__topline" aria-hidden="true"></div>

        <div class="resultado-card__body">
          <div class="resultado-card__header">
            <div>
              <span class="resultado-card__eyebrow">Reporte #</span>
              <h2>{{ denunciaConsultada.codigoSeguimiento }}</h2>
            </div>

            <div class="resultado-card__meta">
              <span class="resultado-card__eyebrow">Fecha de creación</span>
              <strong>{{ denunciaConsultada.fechaRegistro | date:'d MMMM, y' | titlecase }}</strong>
            </div>
          </div>

          <section class="resultado-card__section">
            <span class="resultado-card__eyebrow">Última actualización</span>
            <div class="categoria-pill">
              <span class="categoria-pill__icon" aria-hidden="true"></span>
              <span>{{ (denunciaConsultada.fechaUltimaActualizacion || denunciaConsultada.fechaRegistro) | date:'d MMMM, y' | titlecase }}</span>
            </div>
          </section>

          <section class="resultado-card__section">
            <span class="resultado-card__eyebrow">Estado del proceso</span>

            <div class="timeline">
              <div class="timeline__rail"></div>
              <div class="timeline__progress" [style.width]="getProgressWidth()"></div>

              <div class="timeline__steps">
                <div class="timeline__step" [class.timeline__step--active]="isStatusReached(1)" [class.timeline__step--current]="isCurrentStatus(1)">
                  <span class="timeline__dot"></span>
                  <span class="timeline__label">Recibida</span>
                </div>

                <div class="timeline__step" [class.timeline__step--active]="isStatusReached(2)" [class.timeline__step--current]="isCurrentStatus(2)">
                  <span class="timeline__dot"></span>
                  <span class="timeline__label">En Investigación</span>
                </div>

                <div class="timeline__step" [class.timeline__step--active]="isStatusReached(3)" [class.timeline__step--current]="isCurrentStatus(3)">
                  <span class="timeline__dot"></span>
                  <span class="timeline__label">Cerrada</span>
                </div>
              </div>
            </div>
          </section>
        </div>

        <div class="resultado-card__footer">
          <span class="resultado-card__info-icon" aria-hidden="true">i</span>
          <p>{{ getEstadoResumen() }}</p>
        </div>
      </article>

      <div class="confirmacion-actions confirmacion-actions--receipt">
        <button class="btn-secundario" (click)="nuevaDenuncia()">Realizar otra denuncia</button>
        <button class="btn-link" (click)="cerrar()">Cerrar</button>
      </div>
    </section>
  </ng-container>

  <ng-template #consultaDirectaTpl>
    <div class="confirmacion-page__grid">
      <section class="confirmacion-hero">
        <h1>
          Consulta el<br>
          estado de tu<br>
          <span>reporte.</span>
        </h1>

        <p>
          Ingresa el código de seguimiento que recibiste al finalizar tu denuncia para
          verificar el progreso en tiempo real.
        </p>

        <div class="confirmacion-hero__accent" aria-hidden="true"></div>
      </section>

      <section class="confirmacion-panel">
        <div class="consulta-card">
          <label class="consulta-card__label" for="codigoConsultaDirecto">Código de seguimiento</label>
          <input
            id="codigoConsultaDirecto"
            type="text"
            [(ngModel)]="codigoConsulta"
            placeholder="Ej: DEN-2026-7KQ4M2XA"
            (ngModelChange)="onCodigoConsultaChange()"
            (keyup.enter)="consultarEstado()">

          <button class="btn-primary" (click)="consultarEstado()" [disabled]="buscando">
            <span class="btn-primary__search" aria-hidden="true"></span>
            <span>{{ buscando ? 'Consultando...' : 'Consultar Estado' }}</span>
          </button>

          <div class="error-mensaje" *ngIf="errorConsulta">{{ errorConsulta }}</div>
          <div class="error-mensaje" *ngIf="uploadWarning">{{ uploadWarning }}</div>
        </div>

        <!-- Resultado inline (consulta directa) -->
        <article class="resultado-card" *ngIf="denunciaConsultada">
          <div class="resultado-card__topline" aria-hidden="true"></div>

          <div class="resultado-card__body">
            <div class="resultado-card__header">
              <div>
                <span class="resultado-card__eyebrow">Reporte #</span>
                <h2>{{ denunciaConsultada.codigoSeguimiento }}</h2>
              </div>

              <div class="resultado-card__meta">
                <span class="resultado-card__eyebrow">Fecha de creación</span>
                <strong>{{ denunciaConsultada.fechaRegistro | date:'d MMMM, y' | titlecase }}</strong>
              </div>
            </div>

            <section class="resultado-card__section">
              <span class="resultado-card__eyebrow">Última actualización</span>
              <div class="categoria-pill">
                <span class="categoria-pill__icon" aria-hidden="true"></span>
                <span>{{ (denunciaConsultada.fechaUltimaActualizacion || denunciaConsultada.fechaRegistro) | date:'d MMMM, y' | titlecase }}</span>
              </div>
            </section>

            <section class="resultado-card__section">
              <span class="resultado-card__eyebrow">Estado del proceso</span>

              <div class="timeline">
                <div class="timeline__rail"></div>
                <div class="timeline__progress" [style.width]="getProgressWidth()"></div>

                <div class="timeline__steps">
                  <div class="timeline__step" [class.timeline__step--active]="isStatusReached(1)" [class.timeline__step--current]="isCurrentStatus(1)">
                    <span class="timeline__dot"></span>
                    <span class="timeline__label">Recibida</span>
                  </div>

                  <div class="timeline__step" [class.timeline__step--active]="isStatusReached(2)" [class.timeline__step--current]="isCurrentStatus(2)">
                    <span class="timeline__dot"></span>
                    <span class="timeline__label">En Investigación</span>
                  </div>

                  <div class="timeline__step" [class.timeline__step--active]="isStatusReached(3)" [class.timeline__step--current]="isCurrentStatus(3)">
                    <span class="timeline__dot"></span>
                    <span class="timeline__label">Cerrada</span>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <div class="resultado-card__footer">
            <span class="resultado-card__info-icon" aria-hidden="true">i</span>
            <p>{{ getEstadoResumen() }}</p>
          </div>
        </article>

        <div class="confirmacion-actions">
          <button class="btn-secundario" (click)="nuevaDenuncia()">Realizar otra denuncia</button>
          <button class="btn-link" (click)="cerrar()">Cerrar</button>
        </div>
      </section>
    </div>
  </ng-template>
</div>
